import { Dispatch } from '@reduxjs/toolkit'
import { contextSlice } from '../slices'
import { ContextDAO } from '../models'

function getContext() {
  return async (dispatch: Dispatch): Promise<void> => {
    const contextDAO = new ContextDAO()
    const context = await contextDAO.get()

    dispatch(contextSlice.actions.setContext(context))
  }
}

export default getContext
